import { render, staticRenderFns } from "./GroupRebateList.vue?vue&type=template&id=77afdfaa"
import script from "./GroupRebateList.vue?vue&type=script&lang=js"
export * from "./GroupRebateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports